import Nav from 'react-bootstrap/Nav'

export default function ProfileNav(props) {
    
    return (
        <Nav variant="tabs" size="sm" activeKey={props.activeKey} className="px-3 my-3">
        <Nav.Item>
            <Nav.Link eventKey="1" href={`/be/${props.beId}/profiles/${props.profileId}`}>General</Nav.Link>
        </Nav.Item>
        <Nav.Item>
            <Nav.Link eventKey="2" href={`/be/${props.beId}/profiles/${props.profileId}/apiinterfaces`}>API Interfaces</Nav.Link>
        </Nav.Item>
        <Nav.Item>
            <Nav.Link eventKey="3" href={`/be/${props.beId}/profiles/${props.profileId}/devices`}>Devices</Nav.Link>
        </Nav.Item>
        <Nav.Item>
            <Nav.Link eventKey="4" href={`/be/${props.beId}/profiles/${props.profileId}/config`}>Configuration</Nav.Link>
        </Nav.Item>
        {props.debug || localStorage.debug == "true" ?
            <Nav.Item>
                <Nav.Link eventKey="5" href={`/be/${props.beId}/profiles/${props.profileId}/edit`}>Edit JSON</Nav.Link>
            </Nav.Item>
        : null}
        </Nav>
    )
}
